import React, { useEffect, useState } from "react";
import { supabase } from "../../supabaseClient";
import Navigation from "../Navigation/Navigation";
import HomeFooter from "../HomePage/HomeFooter";

const Arhiva = () => {
  const [winners, setWinners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchArchive();
  }, []);

  const fetchArchive = async () => {
    try {
      setLoading(true);
      // Dohvaćamo samo redak s ID-jem 1 jer site_settings ima samo 1 konfiguracijski redak
      const { data, error } = await supabase
        .from("site_settings")
        .select("arhiva_pobjednika")
        .eq("id", 1)
        .single();

      if (error) throw error;

      // Ako polje postoji i ima podatke, sortiramo ih da najnovija godina bude prva
      if (data && data.arhiva_pobjednika) {
        const sortirano = [...data.arhiva_pobjednika].sort(
          (a, b) => b.year - a.year,
        );
        setWinners(sortirano);
      }
    } catch (error) {
      console.error("Greška pri dohvaćanju arhive:", error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navigation />
      <section className="archive-section">
        <h2 className="archive-title">Pobjednici turnira</h2>

        {loading ? (
          <p style={{ color: "#8fa0ba", fontFamily: "Kanit" }}>
            Učitavanje povijesti turnira...
          </p>
        ) : winners.length === 0 ? (
          <p style={{ color: "#8fa0ba", fontFamily: "Kanit" }}>
            Arhiva je trenutno prazna.
          </p>
        ) : (
          <div className="archive-container">
            {winners.map((item, index) => (
              <div key={index} className="archive-card">
                <div className="archive-year-circle">
                  <span>{item.year}</span>
                </div>
                <div className="archive-content">
                  <h3>{item.winner}</h3>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
      <HomeFooter />
    </>
  );
};

export default Arhiva;
